import * as React from "react";
import { Tennis as Scoreboard } from "sb-resp-ui";
import { EventCell, EventName } from "..";
import { EventInformationObject, EventNameObj, EventTextTypeModifiers } from "../../../../data";
import { returnValueHelper, getValueHelper } from "../../../../helpers";

export function EventInfoMultipleItems(eventObj: EventInformationObject) {
    let eventNameObj1: EventNameObj = {
        eventObj,
        onService: returnValueHelper(eventObj.onService === "1", true, false),
        timeStampMdf: eventObj.modifierDatePeriodTimes,
        textTimeScoreText: eventObj.textDatePeriodTime,
        eventTextTypeMdf: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventTextTypeModifiers.modifierEventName, EventTextTypeModifiers.modifierTeamName),
        eventText: returnValueHelper(!!eventObj.pickedEvent.IsOutright, eventObj.event.eventName, eventObj.event.team1Name)
    };
    let eventNameObj2: EventNameObj = {
        eventObj,
        onService: returnValueHelper(eventObj.onService === "2", true, false),
        timeStampMdf: eventObj.modifierTimeScore,
        textTimeScoreText: eventObj.textTimeScore,
        eventTextTypeMdf: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventTextTypeModifiers.modifierEachWay, EventTextTypeModifiers.modifierTeamName),
        eventText: returnValueHelper(!!eventObj.pickedEvent.IsOutright, eventObj.market.eachWayText, eventObj.event.team2Name)
    };
    let eventHasStartedLiveScb = eventObj.eventHasStarted && eventObj.hasLiveScb;
    return (
        <>
            {getValueHelper(eventHasStartedLiveScb, <Scoreboard {...eventObj.scoreboarProps} />)}
            <EventCell>
                {EventName(eventNameObj1, eventHasStartedLiveScb)}
                {EventName(eventNameObj2, eventObj.hasLiveScb)}
            </EventCell>
        </>
    )
}